import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Table } from 'antd';

import { PropTypes } from 'prop-types';
import sortByString, { safeExtractFromObject } from '../../helpers/helpers';
import TableFilterDropdown from '../../common/tables/TableFilterDropdown';
import OntraccrTag from '../../common/OntraccrTag';

import Colors from '../../constants/Colors';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Active',
    dataIndex: 'active',
    key: 'active',
    align: 'center',
    width: 100,
    filters: [{ text: 'Active', value: 1 }, { text: 'Archived', value: 0 }],
    onFilter: (value, record) => record.active === value,
    render: (_, record) => (
      <OntraccrTag
        className={record.active ? 'division-active-tag' : 'division-inactive-tag'}
        textStyle={{ color: record.active ? 'white' : Colors.ONTRACCR_RED }}
      >
        {record.active ? 'Active' : 'Archived'}
      </OntraccrTag>
    ),
    filterDropdown: TableFilterDropdown,
  },
];

export default function DivisionTable({ data = [], type, onSelectChange }) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const divisionCount = useSelector((state) => Object.values(state.settings.divisions).length);
  const ownerId = useSelector((state) => {
    const {
      settings: {
        company: {
          userId,
        } = {},
      } = {},
    } = state;
    return userId;
  });

  const hasMultiple = divisionCount > 1;

  const sortedData = useMemo(() => {
    const activeData = [];
    const archivedData = [];
    data
      .filter((item) => !!item)
      .sort(sortByString('name'))
      .forEach((item) => {
        if (item.active) {
          activeData.push(item);
        } else {
          archivedData.push(item);
        }
      });

    return activeData.concat(archivedData);
  }, [data]);

  const onHeaderRow = useCallback(() => {
    if (!settings?.uxRedesignPt1) return null;
    return {
      className: 'ontraccr-table-header',
    };
  }, [settings]);

  return (
    <div style={{ height: '100%', overflowY: 'hidden' }}>
      <Table
        style={{ height: '100%', paddingLeft: hasMultiple ? 0 : 10 }}
        columns={columns}
        dataSource={sortedData}
        size="small"
        pagination={false}
        scroll={{
          y: 'calc(100vh - 550px)',
        }}
        rowSelection={
          hasMultiple
            ? {
              fixed: true,
              onChange: onSelectChange,
              getCheckboxProps: (record) => ({
                disabled: type === 'users' && (record.id === ownerId || record.isSupport),
                className: settings?.uxRedesignPt1 ? 'ontraccr-checkbox' : '',
              }),
            }
            : null
        }
        rowKey="id"
        onHeaderRow={onHeaderRow}
      />
    </div>
  );
}

DivisionTable.propTypes = {
  data: PropTypes.array,
  type: PropTypes.string.isRequired,
  onSelectChange: PropTypes.func.isRequired,
};

DivisionTable.defaultProps = {
  data: [],
};
